import { RadioQuestionConfig } from '@gripp/shared-logic';
import { OptionList, RuledLines } from '../components/printPrimitives';
import { RoutinePrintQuestion } from './types';

export const RadioPrintQuestion: RoutinePrintQuestion = ({ config }) => {
  const radio = config as RadioQuestionConfig;
  const options = radio.options ?? [];

  // A single-select question saved with no options still has to be answerable
  // on paper, so it falls back to a writable line rather than printing nothing.
  if (options.length === 0) return <RuledLines />;

  return <OptionList options={options} glyph="radio" />;
};
